import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useParams } from "react-router-dom";
import Images from "../../Images";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
// import Table from "../../Components/Inventories/Tables";
import EditDetail from "../../Components/AllProperties/EditDetail";
import ViewDetail from "../../Components/AllProperties/ViewDetail";
import ViewDocument from "../../Components/Properties/ViewDocument";
import Navbar from "../../Components/Navbar";
import { toast } from "react-toastify";

import {
  Bg,
  BoxContainer,
  Underline,
} from "../../Components/Styles/PageStyles";

import {
  FieldWrapper,
  InputGroup,
  Label,
} from "../../Components/Styles/InputStyles";
import { Field, Form, Formik } from "formik";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import moment from "moment";
import GstDetails from "../../Components/AllProperties/GstDetails";
import Table from "../../Components/Inventories/Table";

const Inventories = () => {
  const { id: propId } = useParams();
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [filter, setFilter] = useState("name");
  const [editUser, setEditUser] = useState(false);
  const [gstDetails, setGstDetails] = useState(false);
  const [viewDetail, setViewDetail] = useState(false);
  const [viewDocument, setViewDocument] = useState(false);
  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(90, "days").format("YYYY-MM-DD")
  );

  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const { t } = useTranslation();

  const initialValues = {
    name: "",
    filterVal: filterValue,
    startDate: moment(new Date()).subtract(90, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  const fetchFunction = async () => {
    const body = new FormData();
    body.append("clientId", propId);
    body.append("filterType", filter);
    body.append("filterValue", filterValue);
    body.append("startDate", startDate);
    body.append("endDate", endDate);
    return await axios.post(`${Config.apiUrl}/getallproperties`, body, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const getInventoriesSuccess = (res) => {
    if (res.data.status === "NOK" || res.data.data === false) error = true;
  };

  const getInventoriesError = (res) => {};

  const {
    isLoading,
    mutate: getInventoriesMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getInventoriesSuccess,
    onError: getInventoriesError,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      getInventoriesMutate();
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [filterValue, startDate, endDate]);
  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    getInventoriesMutate();
  };
  const ChangeHandler = (e) => {
    setFilterValue(e.target.value);
  };

  //------- Edit Single Entry -------
  const EditPropertieFunction = async (values) => {
    const body = new FormData();
    body.append("id", values.id);
    body.append("name", values.name);
    body.append("ownerMobile", values.ownerMobile);
    body.append("status", values.status);
    body.append("lockInPeriod", values.lockInPeriod);
    body.append("noticePeriod", values.noticePeriod);
    body.append("address", values.address);
    body.append("streetAddress", values.streetAddress);
    body.append("pincode", values.pincode);
    body.append("clientId", values.clientId);

    return await axios.post(`${Config.apiUrl}/editproperty`, body, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onEditEntrySuccess = (data) => {
    if (data?.data?.status === "OK") {
      toast.success(data?.data?.msg || "Success");
      //refetch();
      getInventoriesMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
    setSelectedData("");
    setEditUser(false);
  };

  const onEditEntryError = (data) => {
    setEditUser(false);
    setSelectedData("");
    toast.error(data?.data?.msg || "An Error Occured");
  };

  const { isLoading: editEntryLoading, mutate: editPropertieMutate } =
    useMutation(EditPropertieFunction, {
      onSuccess: onEditEntrySuccess,
      onError: onEditEntryError,
    });

  const getReportSuccess = (res) => {
    if (res?.statusText === "OK") {
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(res.data);
      link.download = "exported_report.csv";

      link.click();
      toast.success(res?.data?.msg || "Report downloaded successfully");
    } else if (res.statusText === "NOK" || res.data.data === false) {
      toast.error(res?.data?.msg || "Error exporting report");
    }
  };

  const getReportError = (res) => {
    toast.error(error?.res?.data?.msg || "Error exporting report");
  };

  const { isLoading: isReportLoading, mutate: getReportMutate } = useMutation({
    onSuccess: getReportSuccess,
    onError: getReportError,
  });
  const handleButtonClick = () => {
    getReportMutate();
  };

  const DocumentUploadFunction = async (values) => {
    const body = new FormData();
    body.append("id", values.id);
    body.append("clientId", values.clientId);
    body.append("eKyc", values.enableEKyc);
    body.append("policeVerification", values.enablePoliceVerification);
    body.append("createRent", values.createRentAgreement);
    if (values.rentAgreement) {
      body.append("RentAgreement", values.rentAgreement);
    }
    body.append("ownerSignatureImage", values.ownerSignatureImage);

    return await axios.post(`${Config.apiUrl}/addrentagreement`, body, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onDocumentUploadSuccess = (data) => {
    if (data?.data?.status === "OK") {
      toast.success(data?.data?.msg || "Success");
      // refetch();
      getInventoriesMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
    setSelectedData("");
    setViewDocument(false);
  };

  const onDocumentUploadError = (data) => {
    setViewDocument(false);
    setSelectedData("");
    toast.error(data?.response?.data?.msg);
  };

  const { isLoading: documentUploadLoading, mutate: documentUploadMutate } =
    useMutation(DocumentUploadFunction, {
      onSuccess: onDocumentUploadSuccess,
      onError: onDocumentUploadError,
    });

    //---------Gst Details---------
    const GstDetailsFunction =async(values)=>{
      const body = new FormData();

      body.append("id",values.id);
      body.append("clientId",values.clientId);
      body.append("gstNo",values.gstNo);
      body.append("invoiceNoPrefix",values.invoiceNoPrefix);
      body.append("invoiceNo", values.invoiceNo);
      body.append("isGstEnabled", values.isGstEnabled);
      body.append("gstCharges",values.gstCharges);

      return await axios.post(`${Config.apiUrl}/updategstdetails`, body ,{
        headers:{
          authorization: "Bearer " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      });
    };

    const gstDetailsSuccess =(data)=>{
      if(data?.data?.status === "OK"){
        toast.success(data?.data?.msg || "Success");
        getInventoriesMutate();
      }
      else{
        toast.error(data?.data?.msg || "An Error Occured")
      }
      setSelectedData("");
      setGstDetails(false);
    }

    const gstDetailsError = (data) =>{
      setSelectedData("");
      setGstDetails(false);
      toast.error(data?.response?.data?.msg || "An Error Occured")
    }

    const { isLoading : gstDetailsLoading , mutate: gstDetailsMutate}=
    useMutation(GstDetailsFunction,{
      onSuccess:gstDetailsSuccess,
      onError:gstDetailsError,
    })
  return (
    <>
      <Bg
        style={{
          backgroundImage: `url(${Images.BeamsBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
          height: "100vh",
        }}
      >
        <Navbar />

        {/* <Page> */}
        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>{("Inventories")}</Title>
              <Underline />
            </div>
            <Uploader t={t} />
          </div>

          <div className="flex w-full justify-between items-center">
            <Filters
              submitHandler={submitHandler}
              initialValues={initialValues}
              InitialLoading={isLoading}
              setFilter={setFilter}
              setFilterValue={setFilterValue}
              ChangeHandler={ChangeHandler}
              filterValue={filterValue}
              filter={filter}
              user={user}
              handleButtonClick={handleButtonClick}
              isReportLoading={isReportLoading}
              t={t}
            />
          </div>

          {editUser && (
            <EditDetail
              editPropertieMutate={editPropertieMutate}
              editEntryLoading={editEntryLoading}
              setEditUser={setEditUser}
              data={data?.data}
              selectedData={selectedData}
            />
          )}

          {viewDetail && (
            <ViewDetail
              setViewDetail={setViewDetail}
              selectedData={selectedData}
            />
          )}

          {gstDetails && (
            <GstDetails
              setGstDetails={setGstDetails}
              selectedData={selectedData}
              gstDetailsLoading={gstDetailsLoading}
              gstDetailsMutate={gstDetailsMutate}
              data={data?.data}
            />
          )}
          {viewDocument && (
            <ViewDocument
              setViewDocument={setViewDocument}
              selectedData={selectedData}
              documentUploadLoading={documentUploadLoading}
              documentUploadMutate={documentUploadMutate}
            />
          )}
          {!error && !isLoading && data && (
            <TableWrapper>
              <Table
                ApiData={error ? [] : data?.data?.data}
                setSelectedData={setSelectedData}
                selectedData={selectedData}
                setEditUser={setEditUser}
                setViewDetail={setViewDetail}
                setViewDocument={setViewDocument}
                setGstDetails={setGstDetails}
                userType={user.userType}
              />
              {(error || data?.data?.msg === "No data found") && !isLoading && (
                <NotFoundModel />
              )}
            </TableWrapper>
          )}
          {(isLoading || isRefetching) && <Loading />}
        </BoxContainer>
      </Bg>
    </>
  );
};

const Filters = ({
  initialValues,
  submitHandler,
  InitialLoading,
  filter,
  setFilter,
  setFilterValue,
  filterValue,
  ChangeHandler,
  t,
}) => {
  const today = moment().format("YYYY-MM-DD");
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form className="w-full">
        <FilterContainer>
          <div className="flex gap-2 items-end sm:text-base text-xs flex-wrap">
            <div className="flex items-end gap-2">
              <InputGroup className="max-w-[130px]">
                <Label htmlFor="startDate">{t("Start_Date")}:</Label>
                <FieldWrapper className="h-10">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <Field
                    type="date"
                    name="startDate"
                    id="startDate"
                    className="ml-1"
                    max={today}
                  />
                </FieldWrapper>
              </InputGroup>

              <InputGroup className="max-w-[130px]">
                <Label htmlFor="endDate">{t("End_Date")}:</Label>
                <FieldWrapper className="h-10">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <Field
                    type="date"
                    name="endDate"
                    id="endDate"
                    className="ml-1"
                    max={today}
                  />
                </FieldWrapper>
              </InputGroup>
            </div>
            <ApplyBtn disabled={InitialLoading} type="submit">
              {t("Date_filter")}
            </ApplyBtn>
          </div>

          <div className="flex gap-4 items-end">
            {filter !== "status" && filter !== "paystatus" ? (
              <InputGroup className="max-w-[200px]">
                <Label htmlFor="filterVal">{("")}</Label>
                <Field
                  placeholder="Search..."
                  type="text"
                  name="filterVal"
                  id="filterVal"
                  // class=""
                  value={filterValue}
                  onChange={(e) => setFilterValue(e.target.value)}
                  className="ml-1 border border-slate-300 rounded-md px-4 focus:ring-1 focus:ring-primary-color focus:border-primary-color py-2"
                />
              </InputGroup>
            ) : filter === "status" ? ( // Render dropdown for "Status"
              <InputGroup
                className="min-w-[120px]"
                style={{ flexBasis: "content" }}
              >
                <Label htmlFor="filter">{t("Select")}</Label>
                <Select
                  autoComplete="off"
                  className="px-2 bg-transparent text-sm border-none"
                  style={{ height: "40px" }}
                  value={filterValue}
                  onChange={ChangeHandler}
                >
                  <MenuItem value="" disabled>
                    {t("Select Status")}
                  </MenuItem>

                  <MenuItem value="1">{t("Active")}</MenuItem>
                  <MenuItem value="2">{t("Booked")}</MenuItem>
                  <MenuItem value="3">{t("Leased")}</MenuItem>
                  <MenuItem value="4">{t("Hold")}</MenuItem>
                </Select>
              </InputGroup>
            ) : null}
            <InputGroup
              className="min-w-[120px]"
              style={{ flexBasis: "content" }}
            >
              <Label htmlFor="filter">{t("Search By")}</Label>

              <Select
                autoComplete="off"
                className="w-24 px-2 bg-transparent text-sm border-none"
                style={{ height: "40px" }}
                value={filter}
                onChange={(e) => {
                  const selectedFilter = e.target.value;
                  setFilter(selectedFilter);

                  // Prefill "KIPN" for "GId" filter
                  if (selectedFilter === "gId") {
                    setFilterValue("KIPN");
                  } else {
                    setFilterValue(""); // Clear for other filters
                  }
                }}
              >
                <MenuItem value="name">Name</MenuItem>
                <MenuItem value="status">Status</MenuItem>
                <MenuItem value="gId">gId</MenuItem>
              </Select>
            </InputGroup>
          </div>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const Uploader = ({ t }) => {
  return <UploadWrapper></UploadWrapper>;
};
const TableWrapper = tw.h1`my-10 border bg-white rounded-md `;
const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;

const UploadWrapper = tw.div`
 w-full flex justify-end space-x-4 items-center `;

const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;

const FilterContainer = tw.div`flex items-end flex-wrap justify-between gap-4 mt-8`;

export default Inventories;
